import { render, staticRenderFns } from "./DocsAi.vue?vue&type=template&id=297877e6&scoped=true"
import script from "./DocsAi.vue?vue&type=script&lang=js"
export * from "./DocsAi.vue?vue&type=script&lang=js"
import style0 from "./DocsAi.vue?vue&type=style&index=0&id=297877e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297877e6",
  null
  
)

export default component.exports